import Loadable from 'react-loadable';

import { CustomLoadableLoading } from '../../components/loading/loading.js';

const FaqPageAsync = Loadable({
	loader: () => import(/* webpackChunkName: "faq-page" */'./faq.page.js'),
	modules: ['./faq.page.js'],
	webpack: () => [require.resolveWeak('./faq.page.js')],
	loading: CustomLoadableLoading,
});

export default FaqPageAsync;
